export default "__VITE_ASSET__e0470c86__"